import type { IViewPortController, IViewPortManipulationApi } from '@/engine/app/interfaces';

export class ViewPortManipulationApiComposite implements IViewPortManipulationApi {
  private readonly _apis: Array<IViewPortManipulationApi>;

  public constructor(apis: Array<IViewPortManipulationApi>) {
    this._apis = apis;
  }

  public addAPI(api: IViewPortManipulationApi): void {
    this._apis.push(api);
  }

  public getChildrenAPIs(): Array<IViewPortManipulationApi> {
    return this._apis;
  }

  // IViewPortManipulationApi

  public setViewPortController(viewPortController: IViewPortController | undefined): void {
    this._apis.forEach((api: IViewPortManipulationApi) => api.setViewPortController(viewPortController));
  }
}
